import { useModals } from "@/features/modals/hooks";
import { UpcomingTaskItem } from "@/features/tasks/UpcomingTaskItem";
import { WaitingListDetails } from "@/features/workspace/widgets/waitingList/WaitingListDetails";
import { type Task } from "@repo/api";
import { ListView, Text } from "@repo/skapa";
import { t } from "@repo/translation";

export const WaitingListList = ({ list }: { list: Task[] }) => {
  const { pushModal } = useModals();

  const sortedList = [...list].sort((a, b) => {
    if (
      a.completed?.taskCompletedDateTime &&
      b.completed?.taskCompletedDateTime
    ) {
      return (
        new Date(b.completed.taskCompletedDateTime).getTime() -
        new Date(a.completed.taskCompletedDateTime).getTime()
      );
    }
    if (a.taskDate && b.taskDate) {
      return new Date(a.taskDate).getTime() - new Date(b.taskDate).getTime();
    }
    return 0;
  });

  if (list.length === 0) {
    return <Text>{t("prompt.no_waiting_list_tasks")}</Text>;
  }

  return (
    <ListView id="workspace-waiting-list">
      {sortedList.map((item) => (
        <UpcomingTaskItem
          key={item.id}
          inset={false}
          editable={true}
          task={item}
          showProjectInfo
          onClick={() => {
            pushModal({
              type: "TASK",
              task: item,
              context: "WORKSPACE",
              taskDetails: <WaitingListDetails orderId={item.orderId} />,
            });
          }}
        />
      ))}
    </ListView>
  );
};
